module.exports = __webpack_public_path__ + "img/bg3.f12a7edf.png";